import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ManageLayout, FormField } from '@igblsln/control';
import { Dialog } from 'primereact/dialog';
import { getClientProps } from '@igblsln/store';
export default function ViewModal({ displayModal, data, customDiscard }) {
    const { company_name } = getClientProps();
    const renderForm = (control, _register, errors) => {
        return (React.createElement("div", { className: 'pl-4 pt-4 grid p-fluid h-full' },
            React.createElement(FormField, { label: "Receipt ID", name: "receipt_number", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } }),
            React.createElement(FormField, { label: "Date", name: "date", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } }),
            React.createElement(FormField, { label: "Customer Name", name: "customer_name", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } }),
            React.createElement(FormField, { label: "Amount", name: "amount", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } }),
            React.createElement(FormField, { label: "Mode Of Payment", name: "payment_mode", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } }),
            React.createElement(FormField, { label: "Transaction Detail", name: "transaction_detail", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } }),
            React.createElement(FormField, { label: "Account Name", name: "account_name", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } }),
            React.createElement(FormField, { label: "Source of Fund", name: "source_of_fund_name", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } }),
            React.createElement(FormField, { label: "Notes", name: "notes", className: "col-12 md:col-4", control: control, errors: errors, leftSpan: 4, rightSpan: 8, formItem: {
                    component: InputText,
                    componentProps: {
                        disabled: true,
                    }
                } })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { header: `View Construction Receipt`, visible: displayModal, position: 'center', modal: true, style: { width: '70vw' }, onHide: () => customDiscard(), closeOnEscape: true, draggable: false, resizable: false, closable: true },
            React.createElement(ManageLayout, { baseRoute: "/payment/vendorpayment", viewMode: true, bottomControl: true, data: data, hideHeader: true, customDiscard: customDiscard, onSubmit: () => { }, renderForm: renderForm }),
            React.createElement(Button, { style: {
                    margin: 'auto',
                    marginTop: 10,
                    display: 'flex',
                    width: 150
                }, label: "Close", onClick: () => customDiscard() }))));
}
